import { ReactLenis } from 'lenis/dist/lenis-react'
import React, { ReactNode, useEffect, useRef, useState } from 'react'

import { MediaContextProvider } from './media'

interface Props {
  children: ReactNode
}

export const ClientFeatures = ({ children }: Props) => {
  const lenisRef = useRef<any>(null)
  const [isClient, setIsClient] = useState(false)
  const [smoothScroll, setSmoothScroll] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    setIsClient(true)
    setSmoothScroll(window.innerWidth > 1199)

    const handleResize = () => {
      setSmoothScroll(window.innerWidth > 1199)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (!smoothScroll || !lenisRef.current?.lenis) return

    const lenis = lenisRef.current.lenis

    const handleKeyDown = (e: KeyboardEvent) => {
      const step = window.innerHeight / 2
      const actions: Record<string, number | 'top' | 'bottom'> = {
        ArrowDown: window.scrollY + step,
        ArrowUp: window.scrollY - step,
        Home: 'top',
        End: 'bottom'
      }

      const action = actions[e.key]
      if (!action) return
      e.preventDefault()

      lenis.scrollTo(
        action === 'top'
          ? 0
          : action === 'bottom'
            ? document.body.scrollHeight
            : action
      )
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [smoothScroll])

  return (
    <MediaContextProvider>
      {isClient && smoothScroll ? (
        <ReactLenis
          options={{
            duration: 2,
            lerp: 0.9
          }}
          ref={(el) => {
            lenisRef.current = el
            if (typeof window !== 'undefined') {
              window.__lenis = el?.lenis
            }
          }}
          root
        >
          {children}
        </ReactLenis>
      ) : (
        <>{children}</>
      )}
    </MediaContextProvider>
  )
}
